/**
 * Spoken examples for the coπ tutorial on /help (Gordon 2026-11-02: "show,
 * show me, show me the … are all the same, but show this or that is faster —
 * add a coπ tutorial in the help page"). Hand-written, not machine-translated:
 * coπ understands English, Swedish, Spanish and French, so every other UI
 * language shows the English phrases (which work everywhere). Each phrase is
 * one coπ already understands (lib/copi-commands, src/lib/copi-show.test.ts).
 */
export type CopiExampleKey = 'pages' | 'people' | 'shop' | 'names' | 'mine' | 'playName' | 'playStyle' | 'control' | 'learn' | 'tools';

export const COPI_HELP_EXAMPLES: Record<'en' | 'sv' | 'es' | 'fr', Record<CopiExampleKey, string[]>> = {
  en: {
    pages: ['show news', 'show artists', 'show videos', 'show events', 'show people', 'show DJ'],
    people: ['show guitarists', 'show singers', 'show producers', 'show DJs'],
    shop: ['show t-shirts', 'show hoodies', 'show vinyl', 'show magazines'],
    names: ['show Ski', 'show Leafnuts', 'show hip hop', 'show jazz artists'],
    mine: ['show my profile', 'show my music', 'show my orders', 'show my tokens'],
    playName: ['play Leafnuts', 'play Money Bells', 'play the album Un Nouvel Espoir'],
    playStyle: ['play some jazz', 'play hip hop at 90 bpm', 'play a random video', 'surprise me'],
    control: ['pause', 'next', 'previous', 'play it again'],
    learn: ['teach me the circle of fifths', 'give me a production tip', 'show me a diminished chord in F sharp', 'play a funk groove', 'note reading'],
    tools: ['memo', 'snap a receipt', 'open the tuner'],
  },
  sv: {
    pages: ['visa nyheter', 'visa artister', 'visa videor', 'visa evenemang', 'visa folk', 'visa DJ'],
    people: ['visa gitarrister', 'visa sångare', 'visa producenter', 'visa DJs'],
    shop: ['visa t-tröjor', 'visa huvtröjor', 'visa vinylskivor', 'visa tidningar'],
    names: ['visa Ski', 'visa Leafnuts', 'visa hip hop', 'visa jazz artister'],
    mine: ['visa min profil', 'visa mina låtar', 'visa mina beställningar', 'visa mina tokens'],
    playName: ['spela Leafnuts', 'spela Money Bells', 'spela albumet Un Nouvel Espoir'],
    playStyle: ['spela lite jazz', 'spela hiphop i 90 bpm', 'spela en slumpmässig video', 'överraska mig'],
    control: ['pausa', 'nästa', 'föregående', 'spela igen'],
    learn: ['lär mig kvintcirkeln', 'ge mig ett produktionstips', 'visa ett förminskat ackord i fiss', 'visa trummönster för jazz', 'läsa noter'],
    tools: ['memo', 'fota kvittot', 'öppna stämapparaten'],
  },
  es: {
    pages: ['muestra noticias', 'muestra artistas', 'muestra videos', 'muestra eventos', 'muestra gente', 'muestra DJ'],
    people: ['muestra guitarristas', 'muestra cantantes', 'muestra productores', 'muestra DJs'],
    shop: ['muestra camisetas', 'muestra sudaderas', 'muestra vinilos', 'muestra revistas'],
    names: ['muestra Ski', 'muestra Leafnuts', 'muestra hip hop'],
    mine: ['muestra mi perfil', 'muestra mis canciones', 'muestra mis pedidos', 'muestra mis tokens'],
    playName: ['pon Leafnuts', 'pon Money Bells', 'pon el álbum Un Nouvel Espoir'],
    playStyle: ['pon algo de jazz', 'pon hip hop a 90 bpm', 'pon un video aleatorio', 'sorpréndeme'],
    control: ['pausa', 'siguiente', 'anterior', 'otra vez'],
    learn: ['enséñame el círculo de quintas', 'dame un consejo de producción', 'muéstrame una escala lidia en si bemol', 'pon un ritmo de salsa', 'leer notas'],
    tools: ['nota de voz', 'escanea el recibo', 'abre el afinador'],
  },
  fr: {
    pages: ['montre actualités', 'montre artistes', 'montre vidéos', 'montre événements', 'montre personnes', 'montre DJ'],
    people: ['montre guitaristes', 'montre chanteurs', 'montre producteurs', 'montre DJs'],
    shop: ['montre t-shirts', 'montre sweats', 'montre vinyles', 'montre revues'],
    names: ['montre Ski', 'montre Leafnuts', 'montre hip hop'],
    mine: ['montre mon profil', 'montre mes morceaux', 'montre mes commandes', 'montre mes jetons'],
    playName: ['joue Leafnuts', 'joue Money Bells', "joue l'album Un Nouvel Espoir"],
    playStyle: ['joue du jazz', 'joue du hip hop à 90 bpm', 'joue une vidéo au hasard', 'surprends-moi'],
    control: ['pause', 'suivant', 'précédent', 'encore'],
    learn: ['apprends-moi le cycle des quintes', 'donne-moi une astuce de production', 'montre-moi un accord diminué en fa dièse', 'montre-moi une ligne de basse funk', 'lire les notes'],
    tools: ['mémo vocal', 'prends en photo la facture', "ouvre l'accordeur"],
  },
};
